interface Config {
  apiUrl: string;
  wialonBaseLoginUrl: string;
  environment: string;
}

const defaultConfig: Config = {
  apiUrl: "http://localhost",
  wialonBaseLoginUrl: "https://hosting.wialon.com/login.html",
  environment: "development",
};

// Export configuration
const config: Config = {
  ...defaultConfig,
  apiUrl: process.env.REACT_APP_API_URL || defaultConfig.apiUrl,
  wialonBaseLoginUrl:
    process.env.REACT_APP_WIALON_LOGIN_URL || defaultConfig.wialonBaseLoginUrl,
  environment: process.env.REACT_APP_ENV || defaultConfig.environment,
};

export default config;
